export function Dateformater(inputDate) {
    const date = new Date(inputDate);
    const formattedDate = `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
    return formattedDate
}